import { Injector, NgModule } from '@angular/core';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ChartsModule } from 'ng2-charts';
import { ChassisCoreModule, FormsModule, MenuService, PluginService, PluginService2, TenantUserPlugin } from '@kaiser-software/chassis-core';
import { Components } from './components';
import { Plugins } from './plugins';
import { Modals } from './modals';
import { Services } from './services';
import { Pages } from './pages';
import { AddWorkLogPlugin } from './work-logs/plugins/add-work-log/add-work-log.plugin';
import { CommentsPlugin } from './observations/plugins/comments/comments.plugin';
import { AddObservationHeaderButtonPlugin } from './observations/plugins/add-observation-header-button/add-observation-header-button.plugin';
import { LocationListPlugin } from './locations/plugins/location-list/location-list.plugin';
import { StatusPlugin } from './observations/plugins/status/status.plugin';

@NgModule({
    imports: [
        ChassisCoreModule,
        // DonnaCoreModule,
        // ChassisCommentsModule,
        ChartsModule,
        DatepickerModule,
        BsDropdownModule.forRoot(),
        FormsModule,
    ],
    declarations: [
        Pages,
        Modals,
        Plugins,
        Components,
    ],
    entryComponents: [
        Pages,
        Modals,
        Plugins,
        Components,
    ],
    providers: [
        Services,
    ],
    exports: [
        ChassisCoreModule,
    ]
})
export class EyeWatchBootstrapModule {

    constructor(
        protected injector: Injector,
        protected menus: MenuService,
        protected plugins: PluginService,
        protected pluginService2: PluginService2,
    ) {
        // Sidebar menu
        const sidebar = menus.get('sidebar');

        const settings = sidebar.get('settings');
        settings.delete('private-limited-companies.index');
        settings.delete('locations.index');
        settings.delete('addresses.index');

        sidebar.add('observations', 'Observations', 'observations.index', {
            icon: 'fa fa-eye',
            order: 10,
        });

        // Observation categories
        sidebar.add('observation-categories', 'Categories', 'observation-categories.index', {
            // permission: 'observation_category.read'
            role: ['admin'],
        });

        const types = sidebar.get('observation-categories');
        
        types.add('observation-categories-all', 'All', 'observation-categories.index', {
            // permission: 'observation_category.read'
            role: ['admin'],
        });
        types.add('observation-categories-create', 'New', 'observation-categories.create', {
            // permission: 'observation_category.write'
            role: ['admin'],
        });

        sidebar.add('work-logs', 'Work logs', 'work-logs.index', {
            icon: 'fal fa-clock',
            order: 20,
            role: ['admin']
        });

        // Customers
        sidebar.get('users').delete('tenants');
        const customers = sidebar.add('customers', 'Customers', 'tenants.index', {
            icon: 'fa fa-user-md',
            order: 10,
            permission: 'user.read'
        });


        // Plugins
        plugins.remove('form-tax-settings-plugin', 'form-tax-settings-plugin');

        plugins.add('eyewatch-observations-edit-after', 'observation-comments', CommentsPlugin);
        plugins.add('chassis-core-tenant-edit-sidebar', 'account-comments', CommentsPlugin, 10);
        plugins.add('chassis-core-tenant-edit-after', 'account-locations', LocationListPlugin);

        plugins.add('header-left', 'add-work-log-button', AddWorkLogPlugin);
        plugins.add('header-left', 'add-observation-button', AddObservationHeaderButtonPlugin);

        plugins.add('eyewatch-location-create-modal', 'eyewatch-modal-tenant-users', TenantUserPlugin);
        plugins.add('eyewatch-location-edit-modal', 'eyewatch-modal-tenant-users', TenantUserPlugin);

        this.pluginService2.add(
            [
                'eyewatch-observations-create-sidebar',
                'eyewatch-observations-edit-sidebar'
            ],
            'observation-status',
            StatusPlugin
        );
    }

}



// WEBPACK FOOTER //
// ./apps/eyewatch/src/app/eyewatch/eyewatch-bootstrap.module.ts